import { render } from "./ActionHistory.vue?vue&type=template&id=d164ead4&scoped=true"
import script from "./ActionHistory.vue?vue&type=script&lang=js"
export * from "./ActionHistory.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d164ead4"

export default script